export default __webpack_public_path__ + "static/media/question.6b8643d4.svg";